import React from "react";
import { NavLink, useLocation } from "react-router-dom";

/**
 * TopNav — XT-style horizontal navigation links (desktop only).
 * Sits in the header between the logo and the right-side controls,
 * mirroring xt.com's "Markets · Trade · Finance · ..." menu, but
 * mapped to this app's real routes.
 */
const LINKS = [
  { label: "Markets", to: "/dashboard" },
  { label: "Trade", to: "/trade" },
  { label: "Deposit", to: "/deposit" },
  { label: "Withdraw", to: "/withdraw" },
  { label: "Orders", to: "/transactions" },
  { label: "KYC", to: "/kyc" },
];

const TopNav: React.FC = () => {
  const location = useLocation();
  if (location.pathname.startsWith("/admin")) return null;

  return (
    <nav className="hidden lg:flex items-center gap-1 ml-4">
      {LINKS.map((l) => (
        <NavLink
          key={l.to}
          to={l.to}
          className={({ isActive }) =>
            `px-3 py-1.5 rounded-lg text-[13px] font-semibold transition-colors ${
              isActive
                ? "text-gray-50"
                : "text-gray-400 hover:text-gray-50"
            }`
          }
        >
          {l.label}
        </NavLink>
      ))}
    </nav>
  );
};

export default TopNav;
